export const workflowIssues = [
    {
        icon: '/img/Labour intensive checks.png',
        title: 'Labour-intensive checks',
    },
    {
        icon: '/img/Lack of visibility.png',
        title: 'Lack of visibility',
    },
    {
        icon: '/img/Inefficient scheduling.png',
        title: 'Inefficient scheduling',
    },
    {
        icon: '/img/Inconsistent maintenance.png',
        title: 'Inconsistent maintenance logs',
    },
    {
        icon: '/img/Reduce resale value.png',
        title: 'Missed damage = Higher cost',
    }
];

export const builtForList = [
    {
        icon: '/img/AI powered damage detection.png',
        title: 'AI-powered Damage Detection',
    },
    {
        icon: '/img/Digital condition report.png',
        title: 'Digital condition report',
    },
    {
        icon: '/img/Track incremental damage.png',
        title: 'Track incremental damage',
    },
    {
        icon: '/img/Scanning.png',
        title: 'Scan via phone or fixed cameras',
    },
    {
        icon: '/img/Bulk vehicle scanning.png',
        title: 'Bulk Vehicle Scanning',
    }
];

export const stats = [
    {
        value: '90%',
        label: 'Faster Inspections'
    },
    {
        value: '25%',
        label: 'Drop in unexpected maintenance'
    },
    {
        value: '30%',
        label: 'Lower Operational Costs'
    },
    {
        value: '100%',
        label: 'Digital Reports'
    }
];

export const capabilities = [
    {
        icon: '/img/Track condition of new vehicles.png',
        title: 'Track condition of newly purchase vehicles',
        text: 'Make note of pre-existing damage & improve asset health management'
    },
    {
        icon: '/img/Schedule maintenance planning.png',
        title: 'Scheduled maintenance planning',
        text: 'Helps keep vehicle health in check & avoid any last-minute downtime'
    },
    {
        icon: '/img/Pre trip shift inspection.png',
        title: 'Automated Check-in/check-out inspections',
        text: 'Regular inspections to keep track of incremental damage'
    },
    {
        icon: '/img/Logistics yard management.png',
        title: 'Logistics yard management(bulk scan)',
        text: 'Improved inspection efficiency for larger fleets'
    },
    {
        icon: '/img/Vehicle off boarding.png',
        title: 'Vehicle off-boarding(to retire vehicle)',
        text: 'Ensures that the vehicle is used to its full extent'
    }
];

